import { Outlet } from 'react-router';
import FrontendLayout from '@/components/layout/FrontendLayout';

export function DeskLayoutRoute() {
    return (
        <FrontendLayout frontend="desk">
            <Outlet />
        </FrontendLayout>
    );
}
